import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

export default (affectedId) => {
  const fetchUrl = `purchase/quantification/download/binnacle/${affectedId}/`;
  return errorHandler(Vue.$http.get(fetchUrl))
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', "bitacora.pdf")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
    .catch((err) => {
      throw err
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/downloadBinnacle.js